import {
  Box,
  Button,
  Checkbox,
  Chip,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import CopyToClipboard from "react-copy-to-clipboard";
import utils from "../../../../utils";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const TableCupomDesconto = ({
  cupomList,
  page,
  rowsPerPage,
  handleChangePage,
  onCopy,
  handleClickOpenEdit,
  handleDelete,
  handleChangeRowsPerPage,
}) => {
  return (
    <Box sx={{ padding: "1rem", marginTop: "1rem" }}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="left">Cupom</TableCell>

              <TableCell align="left">Tipo / Valor</TableCell>

              <TableCell align="left">Início</TableCell>

              <TableCell align="left">Término</TableCell>

              <TableCell align="left">Pedido mínimo</TableCell>

              <TableCell align="center">Ignorar promoção</TableCell>

              <TableCell align="center">Válido para</TableCell>
              <TableCell align="center" />
            </TableRow>
          </TableHead>

          <TableBody>
            {cupomList
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((cupom, index) => {
                return (
                  <TableRow key={cupom.id}>
                    <TableCell align="left">
                      <CopyToClipboard
                        fullWidth
                        text={cupom.cupom}
                        variant="outlined"
                        onCopy={onCopy}
                      >
                        <Button color="primary">{cupom.cupom}</Button>
                      </CopyToClipboard>
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        variant="outlined"
                        size="medium"
                        label={
                          cupom.tipo === "VALOR_FIXO"
                            ? utils.formatNumber(cupom.valor)
                            : cupom.tipo === "PERCENTUAL_DA_CONTA"
                            ? `% ${utils.formataMonetario(cupom.valor)}`
                            : cupom.tipo === "ENTREGA_GRATIS"
                            ? "Entrega grátis"
                            : ""
                        }
                        color="primary"
                      />
                    </TableCell>
                    <TableCell align="center">
                      {utils.formatarDataHora(cupom.inicio)}
                    </TableCell>
                    <TableCell align="center">
                      {utils.formatarDataHora(cupom.termino)}
                    </TableCell>
                    <TableCell align="center">
                      {utils.formatNumber(cupom.pedidoValorMinimo)}
                    </TableCell>
                    <TableCell align="center">
                      <Checkbox
                        disabled
                        checked={cupom.ignorarProdutosPromocao}
                      />
                    </TableCell>
                    <TableCell align="center">
                      {cupom.tipoCupom === "DELIVERY" ? "Delivery" : "Local"}
                    </TableCell>
                    <TableCell scope="medium" align="right" xs={2}>
                      <Button
                        onClick={(event) => {
                          handleClickOpenEdit(cupom);
                        }}
                        startIcon={<EditIcon />}
                      >
                        Editar
                      </Button>

                      <IconButton
                        variant="text"
                        onClick={(event) => {
                          handleDelete(cupom, index);
                        }}
                        size="large"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={cupomList.length}
          rowsPerPage={rowsPerPage}
          labelRowsPerPage="Linhas por página"
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </Box>
  );
};

export default TableCupomDesconto;
